// @ts-nocheck
// tslint:disable
export var WebGL2RenderingContext = {};